// Classificação simples do arquivo (ícone e rótulo na lista de documentos).
import { extensionOf } from '@services/documentUploadUtils';

export type FileKind = 'pdf' | 'image' | 'word' | 'sheet' | 'text' | 'other';

export const FILE_KIND_LABELS: Record<FileKind, string> = {
  pdf: 'PDF',
  image: 'Imagem',
  word: 'Word',
  sheet: 'Planilha',
  text: 'Texto',
  other: 'Arquivo',
};

export const fileKindOf = (fileName: string, contentType?: string): FileKind => {
  const ext = extensionOf(fileName);
  const type = (contentType ?? '').toLowerCase();
  if (ext === 'pdf' || type === 'application/pdf') return 'pdf';
  if (['jpg', 'jpeg', 'png', 'heic', 'webp'].includes(ext) || type.startsWith('image/')) return 'image';
  if (['doc', 'docx'].includes(ext) || type.includes('msword') || type.includes('wordprocessingml')) return 'word';
  if (['xls', 'xlsx'].includes(ext) || type.includes('ms-excel') || type.includes('spreadsheetml')) return 'sheet';
  if (ext === 'txt' || type.startsWith('text/')) return 'text';
  return 'other';
};
